import { Expose } from 'class-transformer';

export enum ServicePriceType {
  M3 = 'M3',
  UNIT = 'UNIT',
  MG = 'MG',
  HOUR = 'HOUR',
}

export enum Currency {
  EUR = 'EUR',
}

export enum ServicePriceBearer {
  ORGANIZATION_COST = 'ORGANIZATION_COST',
  ORGANIZATION_REVENUE = 'ORGANIZATION_REVENUE',
}

export class ServicePrice {
  @Expose()
  price?: number;

  @Expose()
  priceType?: ServicePriceType;

  @Expose()
  currency?: Currency;

  @Expose()
  bearer?: ServicePriceBearer;

  @Expose()
  comment?: string;

  @Expose()
  navResourceId?: string;
}
